import { motion } from "framer-motion";
import { Link } from "wouter";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

export default function SoftwareDevelopment() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />

      {/* Hero Section */}
   <section className="relative pt-20 sm:pt-28 md:pt-36 pb-16 sm:pb-20 md:pb-24 overflow-hidden">
  {/* Soft background */}
  <div className="absolute inset-0 bg-gradient-to-b from-white via-gray-50 to-gray-100" />

  {/* Decorative blur - Mobile ke liye chota */}
  <div className="absolute -top-16 sm:-top-20 md:-top-24 left-1/2 -translate-x-1/2 w-[300px] h-[300px] sm:w-[400px] sm:h-[400px] md:w-[600px] md:h-[600px] bg-indigo-100 rounded-full blur-[80px] sm:blur-[100px] md:blur-[120px] opacity-40 sm:opacity-50 md:opacity-60" />

  <div className="relative z-10 container mx-auto px-4 sm:px-6">
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
      className="max-w-4xl mx-auto text-center"
    >
      {/* Badge - Mobile ke liye adjust */}
      <motion.span
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.1, duration: 0.4 }}
        className="inline-flex items-center gap-1.5 sm:gap-2 mb-4 sm:mb-5 md:mb-6 px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 rounded-full bg-indigo-50 text-indigo-600 text-xs sm:text-sm font-semibold shadow-sm"
      >
        🚀 Custom Software Development
      </motion.span>

      {/* Heading - Mobile responsive */}
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.7 }}
        className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight sm:leading-tight md:leading-tight text-gray-900 mb-4 sm:mb-5 md:mb-6"
      >
        Build Scalable{" "}
        <br className="hidden xs:block" />
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-blue-600">
          Intelligent Software
        </span>
      </motion.h1>

      {/* Description - Mobile text size */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.35, duration: 0.6 }}
        className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto mb-6 sm:mb-8 md:mb-10 px-2 sm:px-0"
      >
        We design and develop powerful custom software solutions aligned with
        your business goals. Our expert India-based team delivers secure,
        scalable and high-performance applications.
      </motion.p>

      {/* CTA - Mobile layout */}
<motion.div
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.45, duration: 0.6 }}
  viewport={{ once: true }}
  className="flex flex-col md:flex-row justify-center items-center"
>
  {/* Primary CTA */}
  <div className="w-full md:w-auto mb-4 md:mb-0 md:mr-6">
    <Link href="/getintouch">
      <a
        className="
          block
          w-full
          px-6 md:px-8
          py-3 md:py-4
          rounded-xl md:rounded-2xl
          bg-indigo-600
          text-white
          font-semibold
          text-base md:text-lg
          text-center
          shadow-[0_12px_30px_-10px_rgba(79,70,229,0.6)]
          hover:bg-indigo-700
          transition-all
          duration-300
        "
      >
        Get Started
      </a>
    </Link>
  </div>

  {/* Secondary CTA */}
  <div className="w-full md:w-auto">
    <Link href="/service">
      <a
        className="
          block
          w-full
          px-6 md:px-8
          py-3 md:py-4
          rounded-xl md:rounded-2xl
          bg-white
          border border-gray-200
          text-gray-800
          font-semibold
          text-base md:text-lg
          text-center
          shadow-sm
          hover:shadow-md
          transition-all
          duration-300
        "
      >
        View Services
      </a>
    </Link>
  </div>
</motion.div>

    </motion.div>
  </div>
</section>

      <section className="bg-white py-16 sm:py-20">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="mx-auto max-w-5xl">
            <div className="grid gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-start">
              <div>
                <p className="text-sm font-semibold uppercase tracking-wide text-indigo-600">
                  Custom software development in India
                </p>
                <h2 className="mt-3 text-3xl font-extrabold text-gray-950 sm:text-4xl">
                  Business software built around your workflow
                </h2>
                <p className="mt-5 text-lg leading-relaxed text-gray-600">
                  Custom software development means designing a web app, CRM, ERP,
                  automation system or business portal around the exact process your
                  team follows. Instead of adjusting your sales, operations or support
                  work to a generic tool, Variable Soft builds software that reflects
                  your roles, approval flows, reports, integrations and long-term growth.
                </p>
                <p className="mt-4 text-lg leading-relaxed text-gray-600">
                  We help companies replace spreadsheets, disconnected tools and manual
                  follow-up work with secure systems for lead management, task tracking,
                  inventory, billing, dashboards, AI automation, data scraping and
                  customer communication.
                </p>
              </div>

              <div className="rounded-2xl border border-gray-200 bg-gray-50 p-6 shadow-sm">
                <h3 className="text-xl font-bold text-gray-950">What Variable Soft builds</h3>
                <ul className="mt-5 space-y-3 text-gray-700">
                  {[
                    "Custom CRM and sales automation platforms",
                    "ERP, billing, inventory and workflow systems",
                    "Web apps, dashboards, portals and API integrations",
                    "AI assistants, lead scoring and document automation",
                    "Web scraping, data pipelines and reporting tools",
                    "IVR, dialer and cloud call center integrations",
                  ].map((item) => (
                    <li key={item} className="flex gap-3">
                      <span className="mt-2 h-2 w-2 flex-none rounded-full bg-indigo-600" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-12 grid gap-6 md:grid-cols-3">
              {[
                {
                  title: "Discovery and design",
                  text: "We map users, workflows, data, permissions, integrations and reporting needs before development starts.",
                },
                {
                  title: "Development and testing",
                  text: "Our team builds secure modules, APIs, dashboards and automation with practical QA and release checkpoints.",
                },
                {
                  title: "Deployment and support",
                  text: "We help with hosting, migration, training, maintenance, improvements and long-term product support.",
                },
              ].map((item) => (
                <div key={item.title} className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
                  <h3 className="text-lg font-bold text-gray-950">{item.title}</h3>
                  <p className="mt-3 leading-relaxed text-gray-600">{item.text}</p>
                </div>
              ))}
            </div>

            <div className="mt-12 rounded-2xl bg-gray-950 p-6 text-white sm:p-8">
              <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
                <div>
                  <h2 className="text-2xl font-extrabold">Technology stack</h2>
                  <p className="mt-3 text-gray-300">
                    We select the stack around maintainability, performance and the
                    business workflow, not around one fixed template.
                  </p>
                </div>
                <div className="flex flex-wrap gap-3">
                  {["React", "Node.js", "TypeScript", "Python", ".NET", "PHP", "PostgreSQL", "MongoDB", "REST APIs", "Cloud hosting", "AI APIs", "Automation"].map((tech) => (
                    <span key={tech} className="rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm text-gray-100">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="mt-12">
              <h2 className="text-3xl font-extrabold text-gray-950">Custom software FAQs</h2>
              <div className="mt-6 grid gap-5 md:grid-cols-2">
                {[
                  {
                    q: "What is custom software development?",
                    a: "Custom software development is the process of building software around a company's exact workflow, data, users and reporting needs instead of forcing the business to adapt to a ready-made tool.",
                  },
                  {
                    q: "When should a business choose custom software?",
                    a: "Choose custom software when spreadsheets, generic SaaS products or disconnected tools create duplicate work, weak reporting, missed follow-ups or integration problems.",
                  },
                  {
                    q: "Can Variable Soft modernize existing software?",
                    a: "Yes. We can audit existing systems, improve UI, rebuild modules, add APIs, migrate data, strengthen hosting and add AI or automation features.",
                  },
                  {
                    q: "Which industries use these systems?",
                    a: "Our custom systems fit sales teams, real estate, education, ecommerce, service companies, call centers, finance operations and internal workflow teams.",
                  },
                ].map((item) => (
                  <div key={item.q} className="rounded-2xl border border-gray-200 bg-gray-50 p-6">
                    <h3 className="font-bold text-gray-950">{item.q}</h3>
                    <p className="mt-3 leading-relaxed text-gray-600">{item.a}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-12 flex flex-col gap-4 rounded-2xl border border-indigo-100 bg-indigo-50 p-6 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h2 className="text-2xl font-extrabold text-gray-950">Plan a custom software project</h2>
                <p className="mt-2 text-gray-700">
                  Share your workflow, integrations and reporting needs with our team.
                </p>
              </div>
              <Link href="/getintouch">
                <a className="inline-flex justify-center rounded-xl bg-indigo-600 px-6 py-3 font-semibold text-white transition hover:bg-indigo-700">
                  Discuss Your Project
                </a>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
